/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'sarsaparilla';

function OrganizedGroupQuestion({ contactFacility, handleAnswerChange }) {
    return (
        <div className="rec-form-inline-item-wrap">
            <div className="fieldset-question-wrap">
                <fieldset>
                    <legend>
                        <strong>
                            Is this reservation for an organized group (like Scouts or
                            youth group) or a commercial group?
                        </strong>
                    </legend>
                    <div className="rec-form-inline-item-wrap">
                        <div className="rec-form-inline-item">
                            <label
                                htmlFor="prompt-answer-yes1"
                                className="rec-label-radio"
                            >
                                <input
                                    className="rec-input-hide"
                                    type="radio"
                                    value="yes"
                                    id="prompt-answer-yes1"
                                    name="prompt-answer-yesno1"
                                    checked={contactFacility === 'yes'}
                                    onChange={handleAnswerChange}
                                    placeholder="Yes"
                                />
                                <span className="rec-input-radio" />
                                Yes
                            </label>
                        </div>

                        <div className="rec-form-inline-item">
                            <label
                                htmlFor="prompt-answer-no1"
                                className="rec-label-radio"
                            >
                                <input
                                    className="rec-input-hide"
                                    type="radio"
                                    id="prompt-answer-no1"
                                    name="prompt-answer-yesno1"
                                    value="no"
                                    checked={contactFacility === 'no'}
                                    onChange={handleAnswerChange}
                                    placeholder="No"
                                />
                                <span className="rec-input-radio" />
                                No
                            </label>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div aria-live="polite">
                {contactFacility === 'yes' && (
                    <Alert type="info" hasAriaLive>
                        Contact the facility for details on how to make the correct
                        reservation.
                    </Alert>
                )}
            </div>
        </div>
    );
}

OrganizedGroupQuestion.propTypes = {
    contactFacility: PropTypes.string,
    handleAnswerChange: PropTypes.func.isRequired,
};

export default OrganizedGroupQuestion;
